import { useState } from 'react'
import { Link, useNavigate } from '@tanstack/react-router'
import { ChevronDown, History, Map, MapPin, Plus } from 'lucide-react'
import { useSurroundingsPreview } from './SurroundingsPreviewContext'
import {
  SidebarMenuItem,
  SidebarMenuButton,
  SidebarMenuAction,
  SidebarMenuSub,
  SidebarMenuSubItem,
  SidebarMenuSubButton,
  useSidebar,
} from './ui/sidebar'

export function SurroundingsNavItem({ pathname }: { pathname: string }) {
  const [expanded, setExpanded] = useState(true)
  const preview = useSurroundingsPreview()
  const navigate = useNavigate()
  const { setOpenMobile } = useSidebar()
  const active = pathname === '/surroundings'
  const openPage = (action: () => void) => {
    action()
    setOpenMobile(false)
    void navigate({ to: '/surroundings' })
  }
  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        render={
          <Link to="/surroundings" onClick={() => setOpenMobile(false)} />
        }
        isActive={active}
        tooltip="Surroundings"
      >
        <Map />
        <span>Surroundings</span>
      </SidebarMenuButton>
      <SidebarMenuAction
        aria-label={
          expanded ? 'Zwiń submenu Surroundings' : 'Rozwiń submenu Surroundings'
        }
        aria-expanded={expanded}
        aria-controls="surroundings-submenu"
        onClick={() => setExpanded((value) => !value)}
      >
        <ChevronDown className={expanded ? '' : '-rotate-90'} />
      </SidebarMenuAction>
      {expanded && (
        <SidebarMenuSub
          id="surroundings-submenu"
          aria-label="Otoczenie organizacji"
        >
          <SidebarMenuSubItem>
            <SidebarMenuSubButton
              className="w-full"
              render={
                <button type="button" disabled={!preview.organizationId} />
              }
              onClick={() => openPage(preview.startNew)}
            >
              <Plus />
              <span>Nowe otoczenie</span>
            </SidebarMenuSubButton>
          </SidebarMenuSubItem>
          <li className="px-2 pt-3 pb-1 font-mono text-[0.56rem] uppercase tracking-[0.12em] text-muted-foreground">
            Ostatnie adresy
          </li>
          {preview.entries.slice(0, 5).map((entry) => (
            <SidebarMenuSubItem key={entry.id}>
              <SidebarMenuSubButton
                className="w-full"
                render={<button type="button" />}
                isActive={active && preview.selectedId === entry.id}
                aria-current={
                  active && preview.selectedId === entry.id ? 'page' : undefined
                }
                title={entry.address}
                onClick={() => openPage(() => preview.select(entry.id))}
              >
                <MapPin />
                <span>{entry.address}</span>
              </SidebarMenuSubButton>
            </SidebarMenuSubItem>
          ))}
          {!preview.entries.length && (
            <li className="px-2 py-1 text-xs text-muted-foreground">
              Brak zapisanych adresów
            </li>
          )}
          <SidebarMenuSubItem>
            <SidebarMenuSubButton
              className="w-full"
              render={
                <button type="button" disabled={!preview.organizationId} />
              }
              onClick={() => openPage(() => preview.setHistoryOpen(true))}
            >
              <History />
              <span>Wszystkie generacje</span>
            </SidebarMenuSubButton>
          </SidebarMenuSubItem>
        </SidebarMenuSub>
      )}
    </SidebarMenuItem>
  )
}
